import React, { useState } from 'react';
import cn from 'classnames';

import { getTimelineLabel } from '../utils';

import './WorkspaceTimeLine.scss';

type Props = {
  onItemClick: Function;
  timelineGroups: [];
};

function WorkspaceTimeLine({ onItemClick, timelineGroups }: Props) {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleMouseEnter = () => setIsExpanded(true);

  const handleMouseLeave = () => setIsExpanded(false);

  const handleTimeLineDateClick = event => {
    const weekAgo = event.target.dataset.weekAgo;
    onItemClick(weekAgo);
  };

  if (!timelineGroups?.length) return null;

  return (
    <div
      className="workspace-timeline cursor-pointer pr-1 py-2 d-none d-sm-block"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="workspace-timeline-item-list d-flex flex-column justify-content-center align-items-center position-relative w-100">
        {timelineGroups.map(({ weeksAgo }) => (
          <div key={`workspace-timeline-${weeksAgo}`} className="workspace-timeline-item" />
        ))}
      </div>
      <div
        className={cn('workspace-timeline-list d-flex flex-column position-absolute py-2', {
          'workspace-timeline-list--expanded': isExpanded,
        })}
      >
        {timelineGroups.map(({ weeksAgo }) => (
          <div
            key={`workspace-timeline-${weeksAgo}`}
            className="workspace-timeline-date p-1"
            onClick={handleTimeLineDateClick}
            data-week-ago={weeksAgo}
          >
            {getTimelineLabel(weeksAgo)}
          </div>
        ))}
      </div>
    </div>
  );
}

export default WorkspaceTimeLine;
